import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Navbar from './Navbar';
import { ContactSection, Footer } from './Footer';

/** Shared shell for /privacy-policy, /terms-of-service, /refund-policy. */
const LegalPage = ({ eyebrow, title, updated, body, testId }) => {
  useEffect(() => {
    document.title = `${title} | EasyWorks`;
    window.scrollTo(0, 0);
  }, [title]);
  return (
    <div className="min-h-screen bg-[#FAF2E8] font-[Inter]" data-testid={testId}>
      <Navbar />
      <section className="bg-[#FAF2E8] pt-14 pb-8">
        <div className="max-w-4xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-wider text-[#F39200] font-semibold mb-3">{eyebrow}</div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-neutral-900 leading-[1.05]">{title}</h1>
          {updated && <p className="mt-4 text-sm text-neutral-500">Last updated: {updated}</p>}
        </div>
      </section>
      <article className="bg-white py-14">
        <div className="max-w-4xl mx-auto px-5 lg:px-10">
          <div className="prose prose-neutral max-w-none prose-headings:font-extrabold prose-headings:text-neutral-900 prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-3 prose-h3:text-lg prose-h3:mt-8 prose-h3:mb-2 prose-a:text-[#F39200] prose-a:no-underline hover:prose-a:underline prose-strong:text-neutral-900 prose-li:my-1 prose-p:text-neutral-700 prose-p:leading-relaxed">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{body}</ReactMarkdown>
          </div>
        </div>
      </article>
      <ContactSection />
      <Footer />
    </div>
  );
};

export default LegalPage;
